import React, { useEffect, useState } from "react";
import "./App.css";

function App() {
  const [data, setData] = useState([]);
  const [lastUpdated, setLastUpdated] = useState("");

  useEffect(() => {
    const fetchData = async () => {
  try {
    const response = await fetch("https://docs.google.com/spreadsheets/d/e/2PACX-1vQE_UiVod-ZeopWedmi6WNXvRbePDYJVRk_WtFlMZobu2iP9Nw151hp8qmt-jn1PkAGIYdjvZu6dQR_/pub?gid=0&single=true&output=csv");
    const text = await response.text();
    const rows = text.trim().split("\n").map((line) => line.split(","));
    const lastUpdated = new Date().toLocaleTimeString();

    setData(rows.slice(1)); // skip header
    setLastUpdated(lastUpdated);
  } catch (error) {
    console.error("Failed to fetch data:", error);
  }
};

    fetchData();
    const interval = setInterval(fetchData, 30000); // Refresh every 30s
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="dashboard">
      <h1>🐾 Omni Pet Packing Dashboard</h1>
      <p className="updated">Last updated at: {lastUpdated}</p>
      <table>
        <thead>
          <tr>
            <th>Hour</th>
            <th>Ruby</th>
            <th>Bobby G</th>
            <th>Bobby L</th>
            <th>Kallum</th>
            <th>Marcin</th>
            <th>Lydia</th>
            <th>Dylan</th>
            <th>Luke</th>
            <th>Lamarr</th>
            <th>Team Total</th>
            <th>Orders Remaining</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              {row.map((cell, cIdx) => (
                <td key={cIdx}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default App;
